// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionCard-cls1__2_","cls2":"SuggestionCard-cls2_mPi SuggestionCard-cls1__2_"};